
var token = null;

export function setToken(t) {
  token = t;
}

export default async function api(url, data=null, method='GET') {
  const opts = {
    method: method,
    headers: {
      'Content-type': 'application/json',
    },
  };
  if (data) {
    opts.body = JSON.stringify(data);
  }
  if (token) {
    opts.headers.Authorization = `Token ${token}`;
  }
  const response = await fetch(`${API_URL}${url}`, opts);
  if (response.status === 200) {
    return response.json();
  } else if (response.status === 201) {
    return true;
  } else {
    return false;
  }
}